'use client'

import { useEffect, useRef } from 'react'

import { useAirbridgeContext } from '@/shared/config'

export enum HostHomeUserType {
  NONE = '비회원',
  GUEST = '게스트',
  HOST = '호스트',
}

type Props = {
  userType: HostHomeUserType
}

const env = process.env.NEXT_PUBLIC_ENVIRONMENT
const category =
  env === 'live' ? 'live_host_home_viewed' : 'test_host_home_viewed'
const place = env === 'local' || !env ? 'test' : env

export const AirbridgeEventSender = ({ userType }: Props) => {
  const { isInitialized, sendEvent } = useAirbridgeContext()
  const sentRef = useRef(false)

  useEffect(() => {
    if (!isInitialized || sentRef.current) return

    sentRef.current = true

    sendEvent({
      event: category,
      params: {
        label: userType,
        semanticAttributes: { place },
      },
    })
  }, [isInitialized, sendEvent, userType])

  return null
}
